import React from 'react';

import { ContextProps, SignUpContext } from './signUpContext';

function useSignUp(): ContextProps {
  return React.useContext(SignUpContext);
}

export default useSignUp;
